import { AppState } from 'app/store';

export const getSubscription = (state: AppState) =>
  state.subscription?.subscription;

export const getTierList = (state: AppState) => state.subscription.tierList;

export const getSignedCheckoutLink = (state: AppState) =>
  state.subscription._links?.getSignedCheckoutLink;

export const getManageSubscriptionLink = (state: AppState) =>
  state.subscription.subscription?._links.manageSubscription;

export const getSubscriptionProvider = (state: AppState) =>
  state.subscription.subscription?.provider;

export const getTierListLink = (state: AppState) =>
  state.auth.services?.subscriptions?._links.listSubscriptionTiers;

export const getSubscriptionTiersDDLLink = (state: AppState) =>
  state.auth.services?.subscriptions?._links.subscriptionTiersDDL;

export const getCheckSubscriptionLink = (state: AppState) =>
  state.auth.services?.subscriptions?._links.checkSubscription;

export const getCurrencyList = (state: AppState) =>
  state.subscription.currencyConfig?.availableCurrencies;

export const getDefaultCurrency = (state: AppState) =>
  state.subscription.currencyConfig?.proposedCurrency;

export const getSubscriptionTiersDDL = (state: AppState) =>
  state.subscription?.subscriptionTiersDDL;

export const getSubscriptionQuotasLink = (state: AppState) =>
  state.auth.services?.subscriptions?._links.listSubscriptionQuotas;

export const getAllSubscriptionQuotas = (state: AppState) =>
  state.subscription.subscriptionQuota;

export const getTierListLoading = (state: AppState) =>
  state.subscription.tierListLoading;

export const getTiersDDLLoading = (state: AppState) =>
  state.subscription.tiersDDLLoading;

export const getSubscriptionLoading = (state: AppState) =>
  state.subscription.subscriptionsLoading;

export const getQuota = (state: AppState) =>
  getAllSubscriptionQuotas(state)?.[
    state.subscription.subscription?.tier || 'default'
  ];

export const isCoWriterLimitExceeded = (state: AppState) => {
  return (
    state.subscription.activeQuotaRateStats.lyricsCowriterRequestRateLimit
      ?.remaining === 0
  );
};
